import Vue from "vue";
import App from "@/App.vue";
import BootstrapVue from "bootstrap-vue";
import router from "@/router";
import store from "@/store/store";
import i18n from "@/lang/i18n";
import Icon from "vue-awesome/components/Icon";

import "vue-awesome/icons/file-import";
import "vue-awesome/icons/spinner";
import "vue-awesome/icons/pause";
import "vue-awesome/icons/play";
import "vue-awesome/icons/cog";
import "vue-awesome/icons/wrench";
import "vue-awesome/icons/cogs";
import "vue-awesome/icons/edit";
import "vue-awesome/icons/info";
import "vue-awesome/icons/pen";
import "vue-awesome/icons/pen-fancy";
import "vue-awesome/icons/user-tie";
import "vue-awesome/icons/search";
import "vue-awesome/icons/hdd";
import "vue-awesome/icons/file-download";
import "vue-awesome/icons/plus-circle";
import "vue-awesome/icons/minus";
import "vue-awesome/icons/trash";
import "vue-awesome/icons/regular/square";
import "vue-awesome/icons/check";
import "vue-awesome/icons/regular/check-square";
import "vue-awesome/icons/sync-alt";
import "vue-awesome/icons/file-pdf";
import "vue-awesome/icons/th-list";
import "vue-awesome/icons/chart-bar";
import "vue-awesome/icons/clipboard-list";
import "vue-awesome/icons/history";
import "vue-awesome/icons/search-dollar";
import "vue-awesome/icons/tools";
import "vue-awesome/icons/car";
import "vue-awesome/icons/bars";
import "vue-awesome/icons/address-book";
import "vue-awesome/icons/caret-right";
import "vue-awesome/icons/caret-left";
import "vue-awesome/icons/file-pdf";
import "vue-awesome/icons/exclamation-triangle";
import "vue-awesome/icons/star";
import "vue-awesome/icons/regular/file-alt";
import './assets/styles/global.css'


//import 'vue-awesome/icons'

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.component('v-icon', Icon)

new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount("#app");
